export default __webpack_public_path__ + "static/media/about-picture-2.67885879.jpg";